import { Icon, Typography } from "@mui/material";
import { Box } from "@mui/material";
import React, { Fragment } from "react";

export const DayBookEmptyState: React.FC<{
  icon: string;
  title: string;
  message: string;
}> = ({ icon, title, message }) => {
  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 8,
          px: 2,
        }}
      >
        <Icon
          sx={{
            fontSize: 48,
            color: "text.secondary",
            mb: 2,
          }}
        >
          {icon}
        </Icon>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: "text.primary",
            mb: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            textAlign: "center",
            maxWidth: 300,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Fragment>
  );
};
